export const ABERRATIONS_META_ACTIONS = {
    'SET_SEARCH_LINK_CONFIG': 'TEST_META_SET_SEARCH_LINK_CONFIG',
};
